import { rest } from "src/common/rest";
import { apiPlanning } from "src/common/apiUrl";
import { zEntity, ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";
import {
  ZSchedulingPlan,
  zSchedulingPlan,
  ZSchedulingRow,
  zSchedulingRow,
  zSchedulingSettings,
  ZSchedulingSettings,
  ZTasksDeletionCheck,
  zTasksDeletionCheck,
} from "./SchedulingTypes";

export const loadSchedulingSettings = async (
  id: ZUid,
): Promise<ZSchedulingSettings> => {
  const resp = await rest.get(apiPlanning(`/settings/${id}`));
  return zSchedulingSettings.parse(resp.data);
};

export const saveSchedulingSettings = async (
  id: ZUid,
  settings: ZSchedulingSettings,
) => {
  await rest.post(apiPlanning(`/settings/${id}`), settings);
};

export const loadSchedulingData = async (
  entityId: ZUid,
  objectServiceId: ZUid,
): Promise<ZSchedulingPlan> => {
  const resp = await rest.get(
    apiPlanning(`/plan/${objectServiceId}/${entityId}`),
  );
  return zSchedulingPlan.parse(resp.data);
};

export const createTaskFromTemplate = async (
  entityId: ZUid,
  templateEntityId: ZUid,
  objectServiceId: ZUid,
) => {
  await rest.post(apiPlanning("/plan/createTaskFromTemplate"), {
    entityId,
    templateEntityId,
    objectServiceId,
  });
};

export const createGroupFromTemplate = async (
  entityId: ZUid,
  templateEntityId: ZUid,
  objectServiceId: ZUid,
) => {
  await rest.post(apiPlanning("/plan/createGroupFromTemplate"), {
    entityId,
    templateEntityId,
    objectServiceId,
  });
};

export const createPlanFromTemplate = async (
  entityId: ZUid,
  templateEntityId: ZUid,
  objectServiceId: ZUid,
) => {
  await rest.post(apiPlanning("/plan/createPlanFromTemplate"), {
    entityId,
    templateEntityId,
    objectServiceId,
  });
};

export const createTask = async (
  entityId: ZUid,
  task: ZEntity,
  objectServiceId: ZUid,
): Promise<ZEntity> => {
  const { id, ...other } = task;
  const result = await rest.post(
    apiPlanning(`/plan/${objectServiceId}/${entityId}/tasks`),
    other,
  );
  return zEntity.parse(result.data);
};

export const checkDeleteTasks = async (
  entityId: ZUid,
  taskIds: ZUid[],
  objectServiceId: ZUid,
): Promise<ZTasksDeletionCheck> => {
  const resp = await rest.post(
    apiPlanning(`/plan/${objectServiceId}/${entityId}/tasks/checkDelete`),
    taskIds,
  );
  return zTasksDeletionCheck.parse(resp.data);
};

export const deleteTasks = async (
  entityId: ZUid,
  taskIds: ZUid[],
  objectServiceId: ZUid,
): Promise<ZSchedulingRow> => {
  const resp = await rest.delete(
    apiPlanning(`/plan/${objectServiceId}/${entityId}/tasks`),
    {
      data: taskIds,
    },
  );
  return zSchedulingRow.parse(resp.data);
};

export const saveSchedStartDate = async (
  entityId: ZUid,
  startDate: string,
  objectServiceId: ZUid,
) => {
  await rest.post(apiPlanning("/plan/dates"), {
    entityId,
    startDate,
    objectServiceId,
  });
};
